// Arbre du menu "Parametres" porte de frmMain.Designer.vb (parametres.DropDownItems).
// Feuille table  : { label, typpar }        -> ouvre ParametrageTable (?typpar=N)
// Feuille action : { label, action:'id' }    -> stub (a implementer ulterieurement)
// Sous-menu      : { label, enfants:[...] }
const menuParametres = [
    { label: "Transmission...", action: "paramtrans" },
    { label: "Parametres codes regroupement CCAM (T1BIS, 4BIS, 7BIS)", action: "parregroup" },
    { label: "Referentiel CCAM...", action: "ccam" },
    { label: "Specialites", typpar: 0 },
    {
        label: "Organismes destinataires", enfants: [
            { label: "Mise a jour des Organismes destinataires", typpar: 1 },
            { label: "Importation base de reference", action: "organisf" },
            { label: "Importer table GIE orgadest.csv", action: "importorgadest" },
            { label: "Telecharger la table lors de la prochaine teletransmission", action: "importtts" },
            {
                label: "Types de destinataires", enfants: [
                    { label: "Mise a jour des types de destinataires", typpar: 13 },
                    { label: "Importation base de reference", action: "importtypd" },
                ]
            },
        ]
    },
    {
        label: "Comptabilite", enfants: [
            { label: "Modes reglement", typpar: 2 },
            { label: "Banque medecin", typpar: 3 },
            { label: "Banques Patients", typpar: 5 },
            { label: "Correspondance Ag2035", typpar: 19 },
        ]
    },
    {
        label: "Conventions complementaires / Mutuelles", enfants: [
            { label: "table mutuelles et complementaires", typpar: 4 },
            { label: "mise a jour table des conventions complementaires", action: "majconv" },
            { label: "Table des regroupements AMC", typpar: 14 },
            { label: "Table de correspondance Mutuelles", typpar: 15 },
        ]
    },
    {
        label: "Parcours de soins", enfants: [
            { label: "Diminution de taux hors parcours (T14)", typpar: 28 },
            { label: "Prestations soumises a majoration T.M. (T14.1)", typpar: 24 },
            { label: "Specialites exclues et contextes particuliers (T15.1,T16.X,T18)", typpar: 23 },
            { label: "Situations beneficiaires exclues (T15.2)", typpar: 22 },
            { label: "Depassements possibles selon le contexte (A0T2 T2BIS)", typpar: 21 },
            { label: "Prestations contexte urgence (T5BIS)", typpar: 27 },
            { label: "Compatibilite majorations coordination selon le contexte (T17)", typpar: 20 },
        ]
    },
    {
        label: "Codes prestations", enfants: [
            { label: "mise a jour Codes prestations (T1)", typpar: 6 },
            { label: "Importation base de reference", action: "majrefcp" },
            { label: "Compatiblites codes prestations (T4, T4BIS)", typpar: 7 },
            { label: "Prestations obligatoirement associees (T12)", typpar: 17 },
            { label: "Ententes prealables/presta (T6)", typpar: 9 },
            { label: "Compatibilite beneficiaire prestations (T3)", typpar: 10 },
        ]
    },
    {
        label: "Tables Diverses", enfants: [
            { label: "Parametres pour une facture anonymisee generique (T10)", typpar: 30 },
            { label: "Jours Feries", action: "jourferie" },
            { label: "Numerotation des lots", typpar: 8 },
            { label: "Importer une table de confreres", action: "impconff" },
            { label: "Medecins traitants", typpar: 29 },
        ]
    },
    { label: "Modeles", action: "parmodele" },
    { label: "Tarifs S.S.", action: "tarifsss" },
    { label: "Tarifs personnels", action: "tarperso" },
];

export default menuParametres;
